import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle} from '@angular/material/dialog';
import {combineLatest, Observable, Subscription, timer} from 'rxjs';
import {ExcelDownloadResponse} from '@services/resource/excel-download-response';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import FileSaver from 'file-saver';
import {MatCard} from '@angular/material/card';
import {MarkantElementsModule} from '@markant/elements-angular';
import {CommonModule} from '@angular/common';

const NOT_FOUND = 404;
const INTERVAL_SEC = 3;

@Component({
  selector: 'app-download-dialog',
  templateUrl: './excel-download-dialog.component.html',
  styleUrls: ['./excel-download-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, MatCard, MatDialogContent, MatDialogActions, MarkantElementsModule, MatDialogClose, MatDialogTitle],
})
export class ExcelDownloadDialogComponent implements OnInit {
  downloadUrl = '';
  durationSec = 0;
  fatalDownloadError = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public conf: DownloadDialogConfig,
    private readonly http: HttpClient,
  ) {}

  private downLoadSub: Subscription;

  ngOnInit() {
    this.downLoadSub = combineLatest([this.conf.downloadResponse, timer(2000, INTERVAL_SEC * 1000)]).subscribe((combiResult) => {
      this.http.get(combiResult[0].url, {responseType: 'blob'}).subscribe(
        (data) => {
          this.saveFileAndUnSub(combiResult, data);
        },
        (error: HttpErrorResponse) => {
          if (error.status === NOT_FOUND) {
            this.durationSec += INTERVAL_SEC;
          } else {
            this.showFatalErrorAndUnSub();
          }
        },
      );
    });
  }

  private saveFileAndUnSub(combiResult: [ExcelDownloadResponse, number], data: Blob) {
    this.downloadUrl = combiResult[0].url;
    this.downLoadSub.unsubscribe();
    FileSaver.saveAs(data, combiResult[0].filename);
  }
  private showFatalErrorAndUnSub() {
    this.fatalDownloadError = true;
    this.downLoadSub.unsubscribe();
  }
}

export interface DownloadDialogConfig {
  fileName: string;
  downloadResponse: Observable<ExcelDownloadResponse>;
}
